module.exports = __webpack_public_path__ + "img/exc.035f1ec8.jpg";